import React, { useMemo } from "react";

import { generateBlockCSS } from "../css";

type Props = {
	clientId: string;
	blockName: string;
	deviceType: "desktop" | "tablet" | "mobile";
	attributes: Record<string, unknown>;
};
const useBlockStyle = (props: Props) => {
	const { clientId, blockName, deviceType, attributes } = props;
	const Style = useMemo<React.FC>(() => {
		const css = generateBlockCSS({
			settings: attributes,
			blockName: blockName,
			blockID: clientId,
			deviceType,
		});

		if (
			"customize" === (window as any).pagenow &&
			(window as any).wp?.customize
		) {
			const inject = () => {
				const doc = (
					window as any
				).wp.customize.previewer.targetWindow().document;

				if (!doc) return;
				const style = Object.assign(document.createElement("style"), {
					id: `mzb-${blockName}-${clientId}-css`,
					innerHTML: css,
				});
				const styleEl = doc.getElementById(
					`mzb-${blockName}-${clientId}-css`
				);

				if (styleEl) {
					styleEl.remove();
				}

				doc.head.appendChild(style);
			};

			inject();
			(window as any).wp.customize.previewer.bind("ready", inject);
		}

		const _Style = () => {
			if (!clientId || !css) return null;
			return <style>{css as string}</style>;
		};
		_Style.displayName = `Style[${blockName}/${clientId}]`;
		return _Style;
	}, [attributes, blockName, clientId, deviceType]);

	return { Style };
};

export default useBlockStyle;
